import React from 'react';
import { motion } from 'framer-motion';
import { ArrowRight, CheckCircle2, TrendingUp } from 'lucide-react';
export function Hero() {
  return <section className="relative pt-16 pb-24 lg:pt-24 lg:pb-32 overflow-hidden bg-ink" data-id="element-144">
      {/* Background grid */}
      <div className="absolute inset-0 bg-grid opacity-60 pointer-events-none" data-id="element-145"></div>
      <div className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-[800px] h-[800px] rounded-full bg-mint/5 blur-3xl pointer-events-none" data-id="element-146"></div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-147">
        {/* Eyebrow */}
        <motion.div initial={{
        opacity: 0,
        y: 10
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.5
      }} className="flex justify-center mb-8" data-id="element-148">
          
          <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-mint-soft border border-mint/20 text-mint text-xs font-medium uppercase tracking-[0.15em]" data-id="element-149">
            <span className="relative flex h-2 w-2" data-id="element-150">
              <span className="animate-ping absolute inline-flex h-full w-full rounded-full bg-mint opacity-75" data-id="element-151"></span>
              <span className="relative inline-flex rounded-full h-2 w-2 bg-mint" data-id="element-152"></span>
            </span>
            For retailers in South Africa
          </div>
        </motion.div>

        {/* Headline */}
        <motion.h1 initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.1
      }} className="display text-bone text-center max-w-5xl mx-auto mb-8" style={{
        fontSize: 'clamp(2.75rem, 7vw, 6rem)'
      }} data-id="element-153">
          
          Get <span className="display-italic text-mint" data-id="element-154">paid</span> faster. <br data-id="element-155" />
          <span className="display-italic text-mint" data-id="element-156">Reach</span> the 12M South
          Africans your app can't.
        </motion.h1>

        <motion.p initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.2
      }} className="text-xl sm:text-2xl text-bone-dim text-center max-w-3xl mx-auto mb-10 font-light leading-relaxed" data-id="element-157">
          
          Masube Settle is the USSD, SMS, and WhatsApp payment layer for retail
          accounts. One integration, daily settlement, every phone.
        </motion.p>

        {/* CTA */}
        <motion.div initial={{
        opacity: 0,
        y: 20
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.6,
        delay: 0.3
      }} className="flex flex-col sm:flex-row gap-4 justify-center mb-16" data-id="element-158">
          
          <a href="#book-demo" className="inline-flex items-center justify-center gap-2 px-8 py-4 min-h-[56px] rounded-full bg-mint text-ink font-semibold text-base hover:bg-mint-dim transition-colors shadow-[0_0_40px_-10px_rgba(43,227,140,0.6)]" data-id="element-159">
            
            Book a demo
            <ArrowRight className="w-4 h-4" data-id="element-160" />
          </a>
          <a href="#try-it" className="inline-flex items-center justify-center gap-2 px-8 py-4 min-h-[56px] rounded-full bg-ink-3 border border-white/10 text-bone font-medium text-base hover:bg-ink-4 transition-colors" data-id="element-161">
            
            See live demo
          </a>
        </motion.div>

        {/* Hero visual: dashboard mock + phone */}
        <motion.div initial={{
        opacity: 0,
        y: 40
      }} animate={{
        opacity: 1,
        y: 0
      }} transition={{
        duration: 0.8,
        delay: 0.4
      }} className="relative max-w-5xl mx-auto" data-id="element-162">
          
          <div className="relative bg-ink-2 rounded-3xl border border-white/10 p-6 lg:p-8 shadow-2xl" data-id="element-163">
            {/* Dashboard header */}
            <div className="flex items-center justify-between mb-6" data-id="element-164">
              <div data-id="element-165">
                <div className="text-xs text-muted uppercase tracking-wider mb-1" data-id="element-166">
                  Edgars · Live
                </div>
                <div className="font-semibold text-bone" data-id="element-167">
                  Collections Dashboard
                </div>
              </div>
              <div className="flex items-center gap-2" data-id="element-168">
                <span className="w-2 h-2 rounded-full bg-mint" data-id="element-169"></span>
                <span className="text-xs text-bone-dim" data-id="element-170">
                  All systems normal
                </span>
              </div>
            </div>

            <div className="grid lg:grid-cols-3 gap-4" data-id="element-171">
              {/* Stat cards */}
              <div className="bg-ink-3 rounded-2xl p-5 border border-white/5" data-id="element-172">
                <div className="text-xs text-muted uppercase tracking-wider mb-2" data-id="element-173">
                  Today
                </div>
                <div className="display text-bone text-3xl mb-1" data-id="element-174">R 1.24M</div>
                <div className="flex items-center gap-1 text-xs text-mint" data-id="element-175">
                  <TrendingUp className="w-3 h-3" data-id="element-176" />
                  +37% vs. last week
                </div>
              </div>
              <div className="bg-ink-3 rounded-2xl p-5 border border-white/5" data-id="element-177">
                <div className="text-xs text-muted uppercase tracking-wider mb-2" data-id="element-178">
                  Active accounts
                </div>
                <div className="display text-bone text-3xl mb-1" data-id="element-179">8,412</div>
                <div className="text-xs text-bone-dim" data-id="element-180">
                  paid via USSD this week
                </div>
              </div>
              <div className="bg-ink-3 rounded-2xl p-5 border border-white/5" data-id="element-181">
                <div className="text-xs text-muted uppercase tracking-wider mb-2" data-id="element-182">
                  Settlement
                </div>
                <div className="display text-bone text-3xl mb-1" data-id="element-183">T+0</div>
                <div className="text-xs text-bone-dim" data-id="element-184">PayShap • 24h</div>
              </div>
            </div>

            {/* Mini transaction feed */}
            <div className="mt-4 bg-ink rounded-2xl border border-white/5 overflow-hidden" data-id="element-185">
              <div className="px-5 py-3 border-b border-white/5 text-xs text-muted uppercase tracking-wider" data-id="element-186">
                Live transactions
              </div>
              {[{
              ref: 'MS-44218',
              amt: 'R 487.50',
              name: 'Nomsa M.',
              ch: 'USSD',
              t: '09:42'
            }, {
              ref: 'MS-44217',
              amt: 'R 1,240.00',
              name: 'Sipho K.',
              ch: 'WhatsApp',
              t: '09:41'
            }, {
              ref: 'MS-44216',
              amt: 'R 215.75',
              name: 'Anna V.',
              ch: 'USSD',
              t: '09:41'
            }].map(row => <div key={row.ref} className="px-5 py-3 flex items-center justify-between border-b border-white/5 last:border-0" data-id="element-187">
                
                  <div className="flex items-center gap-3" data-id="element-188">
                    <div className="w-8 h-8 rounded-full bg-mint-soft flex items-center justify-center" data-id="element-189">
                      <CheckCircle2 className="w-4 h-4 text-mint" data-id="element-190" />
                    </div>
                    <div data-id="element-191">
                      <div className="text-sm text-bone font-medium" data-id="element-192">
                        {row.name}
                      </div>
                      <div className="text-xs text-muted mono" data-id="element-193">
                        {row.ref} · {row.ch}
                      </div>
                    </div>
                  </div>
                  <div className="text-right" data-id="element-194">
                    <div className="text-sm font-semibold text-bone" data-id="element-195">
                      {row.amt}
                    </div>
                    <div className="text-xs text-muted" data-id="element-196">{row.t}</div>
                  </div>
                </div>)}
            </div>
          </div>

          {/* Floating phone mock */}
          <div className="hidden lg:block absolute -right-12 -bottom-12 w-48 transform rotate-6" data-id="element-197">
            <div className="bg-ink-2 rounded-3xl border-4 border-ink-4 p-3 shadow-2xl" data-id="element-198">
              <div className="bg-[#075E54] text-white px-3 py-2 rounded-t-xl text-xs font-semibold flex items-center gap-2" data-id="element-199">
                <div className="w-6 h-6 rounded-full bg-mint flex items-center justify-center text-ink text-[10px] font-bold" data-id="element-200">
                  M
                </div>
                Masube · Edgars
              </div>
              <div className="bg-[#E5DDD5] p-2 rounded-b-xl space-y-1.5" data-id="element-201">
                <div className="bg-white text-gray-800 text-[10px] p-2 rounded" data-id="element-202">
                  Edgars balance: <strong data-id="element-203">R 487.50</strong>. Reply YES to pay.
                </div>
                <div className="bg-[#DCF8C6] text-gray-800 text-[10px] p-2 rounded ml-6" data-id="element-204">
                  YES
                </div>
                <div className="bg-white text-gray-800 text-[10px] p-2 rounded" data-id="element-205">
                  ✓ Paid via PayShap. Ref MS-44218
                </div>
              </div>
            </div>
          </div>
        </motion.div>

        {/* Stats strip */}
        <motion.div initial={{
        opacity: 0
      }} animate={{
        opacity: 1
      }} transition={{
        duration: 0.6,
        delay: 0.6
      }} className="mt-24 grid grid-cols-2 md:grid-cols-4 gap-8 border-t border-white/5 pt-12" data-id="element-206">
          
          {[{
          stat: '12M+',
          label: 'Feature-phone customers reached'
        }, {
          stat: '37%',
          label: 'Avg. collection rate uplift'
        }, {
          stat: 'T+0',
          label: 'Same-day PayShap settlement'
        }, {
          stat: '< 14d',
          label: 'From signup to live'
        }].map(s => <div key={s.label} className="text-center md:text-left" data-id="element-207">
              <div className="display text-mint text-4xl md:text-5xl mb-2" data-id="element-208">
                {s.stat}
              </div>
              <div className="text-sm text-bone-dim" data-id="element-209">{s.label}</div>
            </div>)}
        </motion.div>
      </div>
    </section>;
}